module.exports = __webpack_public_path__ + "img/banner_en.b7ce4a13.jpg";